import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectTypeComponent } from '../project-type/project-type.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService,PAGETYPES, WIDGET_TYPES } from "ngx-mobile-app";
import { WebServiceService } from "ngx-web-app";
import { MatTosterService } from '../../../services/mat-toster.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Location } from '@angular/common';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping, isNullOrUndefined, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';
import { SharedDataService } from '../../../services/shared-data.service';
import { HttpClient } from '@angular/common/http';
import { StreamBlobService } from 'shared-library';

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit,OnDestroy {

  Mobile_type_uuid = "86de7476-8454-11ee-b962-0242ac120002";
  web_type_uuid = "bdfb0b7c-8454-11ee-b962-0242ac120002";

  defPages:any=[];
  webAppExists:boolean = false;
  mobileAppExists:boolean = false;
  webApp:any = {}
  MobileApp:any = {};
  webLogo:any;
  mobileLogo:any;
  projectName!:string;
  spinnerVisible:boolean=false;
  mobileApplicationName: string = '';
  mobileApplicationId: string = '';
  webApplicationName: string = '';
  webApplicationId: string = '';
  defaultPageIconCreated:boolean=false;
  breadcrumbs$!: Observable<{ id: any; label: any, state: any }[]>;
  existedApplication: any = [];
  lastModifyDate:any;
  s3ImageUrl:string = "";
  pageTypes = PAGETYPES;
  widgetTypes = WIDGET_TYPES;
  defaultwebImage!:string;
  resourceData: any;
  private destroy$ = new Subject<void>();

  appPermissions: any = APP_BUILDER_PERMISSIONS;
  permissionsActions: any = PERMISSIONS_ACTIONS;
    
  constructor(public dialog: MatDialog,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private sharedService :SharedService,
    private webSharedService :WebServiceService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toasterSrv:MatTosterService,
    private location: Location,
    private sharedDataService:SharedDataService,
    private http: HttpClient,
    private streamBlobService: StreamBlobService
    ) { }
  projectApplicationListData:any[]=[]
  projectId:any;
 
  ngOnInit() {
    this.revertSetDataInSharedSrv();
    const fullPath = this.location.path();
    const containsApplications = fullPath.includes('/applications');
    if(containsApplications){
      const existBreadcrumb = this.sharedService.getCurrentBreadcrumb();
        if(existBreadcrumb.length > 2){
          const newExitsBreadcrumb  = existBreadcrumb.slice(0,2);
          this.sharedService.updateBreadcrumb(newExitsBreadcrumb);
        }
    }
    this.breadcrumbs$ = this.sharedService.getBreadcrumb();
    const currentParams = { ...this.activatedRoute.snapshot.queryParams };
    
    this.projectId = currentParams['id'];
    this.projectName = currentParams['projectName'];
    this.getApplicationTypes(this.projectId);
    this.getApplications(currentParams['id']);
  }

  getApplicationTypes(projectId:any){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["GET_APPLICATION_TYPES"]
    );
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        data.forEach((obj : any) => {
         obj?.application_type.toLowerCase() == 'mobile' ? this.Mobile_type_uuid = obj.application_type_id : this.web_type_uuid = obj.application_type_id;
        })
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toasterSrv.showError('You do not have permission to access this resource.');
        }else{
          this.toasterSrv.showError('Failed to retrieve the application types. Please try again later.');
        }
      },
    });
  }

  getApplications(id:any){
    this.spinnerVisible = true;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_APPLICATIONS']);
    apiConfig.postData = { id: id }
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.projectApplicationListData=[]
        data.map(async (app:any)=>{
          if(app.application_type_id == this.web_type_uuid)
          {
            this.webApplicationName = app.application_name;
            this.webApplicationId = app.application_id;
            this.webAppExists = true;
            this.webApp = app;
             if(app.blob_name && app.blob_name != null && app.blob_name != ''){
            this.webLogo =  await this.streamBlobService.fetchImage(app.blob_name);
            }else{
              let imageSrc = 'data:image/png;base64,';
              imageSrc = app?.image;
              this.webLogo = imageSrc;
            }
            this.existedApplication.push( this.webApplicationName );
            this.lastModifyDate=app?.last_modified_date
          }
          else if(app.application_type_id == this.Mobile_type_uuid)
          {
            this.mobileApplicationName = app.application_name;
            this.mobileApplicationId = app.application_id;
            this.mobileAppExists = true;
            this.MobileApp = app;
            if(app.blob_name && app.blob_name != null && app.blob_name != ''){
              this.mobileLogo =  await this.streamBlobService.fetchImage(app.blob_name);
            }else{
              let imageSrc = 'data:image/png;base64,';
              imageSrc = app?.image;
              this.mobileLogo = imageSrc;
            }
            this.existedApplication.push( this.mobileApplicationName );
            this.lastModifyDate=app?.last_modified_date
          }
          this.projectApplicationListData.push(app);
        })
        this.spinnerVisible = false;
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toasterSrv.showError('You do not have permission to access this resource.');
        }else{
          this.toasterSrv.showError('Failed to retrieve the applications. Please try again later.');
        }
        this.spinnerVisible = false;
      }
    })
  }


  onApplicationCardClick(index:any){
    index?.meta?.type == 'mobile' ? this.router.navigate(["home","mobile"]) : this.router.navigate(["web"])
  }

  async createDefaulLoginPages(primaryColor: string, applicationTypeId: string, applicationId: string, applicationLogo: File, enableBiometrics: boolean, isWebApp: boolean): Promise<any> {
    let pages: any[] = [];
    if (this.defPages) {
      this.defPages.forEach((page: any) => {
        page = this.keySetter(page);
        if (page.pageType == this.pageTypes.splashScreen && !isWebApp) {
          page.pageConfig.forms[0].widgets[0].widgetConfig.image = this.s3ImageUrl;
          page.pageConfig.forms[0].widgets[0].widgetConfig['additionalConfig'] = {
            imagePath :this.resourceData?.resource_blob ?? '',
                  resourceId: this.resourceData?.resource_id ?? '',
                 resourceVersion: this.resourceData?.resource_version ?? '',
          }
          pages.push(page);
        } else if (page.pageType === this.pageTypes.loginPage && page.masterPageName === 'Default') {
          let actualPage = page.pageConfig;
          actualPage.forms.forEach((form: any) => {
            if (form.formConfig.formType === (applicationTypeId === this.Mobile_type_uuid ? 'section' : 'form')) {
              const imageWidget = form.widgets.find((widget: any) => widget.widgetType === this.widgetTypes.imageUploader);
              if (imageWidget) {
                imageWidget.widgetConfig = imageWidget.widgetConfig || {};
                imageWidget.widgetConfig.image = isWebApp ? this.defaultwebImage : this.s3ImageUrl;
                if(!isWebApp && this.resourceData){
                  imageWidget.widgetConfig['additionalConfig'] = {
                        imagePath :this.resourceData?.resource_blob ?? '',
                        resourceId: this.resourceData?.resource_id ?? '',
                        resourceVersion: this.resourceData?.resource_version ?? '',
                  }
                }
              }
            }
          })
          pages.push(page);
        }
      })
    }

    let navConfig: any = {
      "logo": this.s3ImageUrl,
      "pages": [
      ],
      "title": "Title",
      "userInfo": false,
      "logoutOption": false,
      "selectedOption": "logo"
    }
    pages.filter((page: any) => page.applicationTypeId === applicationTypeId);
    if (pages.length > 0) {
      await this.sharedService.createAllDefaultPages(applicationId, pages, isWebApp ? navConfig : null);
    }
  }

  keySetter(page:any){
    let actualPage = page.pageConfig;
    const current = new Date();
    const timestamp = current.getTime();
    actualPage.forms.forEach((form:any) => {
      form.formKey = form.formLabel+timestamp;
      form.widgets.forEach((widget:any) => {
        widget.widgetKey = widget.widgetLabel + timestamp;
      })
    })
    return page;
  }

  async readFileAsDataURL(applicationLogo: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onloadend = () => {
        const binaryData = reader.result as string;
        resolve(binaryData.split(',')[1]);
      };
  
      reader.onerror = () => {
        reject(new Error('Error reading file as data URL.'));
      };
  
      // Read the file as a data URL
      reader.readAsDataURL(applicationLogo);
    });
  }



  createApplication(res: any, project_id: string, applicationType: string, dialogRef: any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_APPLICATION']);
    if (applicationType === this.Mobile_type_uuid) {
      apiConfig.postData = {
        project_id: project_id,
        application_name: res?.applicationName,
        application_type_id: applicationType,
        application_description: res.applicationDescription,
        biometric: res?.biometrics,
        theme_id: res?.theme_id,
        created_by: "User12",
        modified_by: "User22"
      }
    } else {
      apiConfig.postData = {
        project_id: project_id,
        application_name: res?.applicationName,
        application_type_id: applicationType,
        application_description: res.applicationDescription,
        biometric: res?.biometrics,
        theme_id: res?.theme_id,
        created_by: "User12",
        modified_by: "User22"
      }
    }
    this.spinnerVisible = true;
    dialogRef.close();
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: async (appData: any) => {
        let createdImageS3Url: any
        createdImageS3Url = await this.addApplicationLogo(appData.application_id, res.icon);
        let isWebApp:boolean = applicationType !== this.Mobile_type_uuid;
        await this.createDefaulLoginPages(res.primary_color, applicationType, appData.application_id, res.icon, res.enableBiometrics,isWebApp);
        this.toasterSrv.showToastMessage("Sucessfully Created Application", "success");
        if (applicationType === this.Mobile_type_uuid) {
          const currentParams = { ...this.activatedRoute.snapshot.queryParams };
          currentParams['id'] = appData.application_id;
          this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
            let mobileApplicationData: any = { ...x };
            mobileApplicationData['mobileAppId'] = appData?.application_id
            mobileApplicationData['image'] = createdImageS3Url
            mobileApplicationData['mobileApplicationName'] = res?.applicationName
            localStorage.setItem("mobileMeta", JSON.stringify(mobileApplicationData))
             localStorage.setItem("appDetails",JSON.stringify(mobileApplicationData))
          })
          const currentBreadcrumb = this.sharedService.getCurrentBreadcrumb();
          const newBreadcrumbObj = { id: appData.application_id, label: res?.applicationName, state: 'mobile' };
          const newBreadcrumb = [...currentBreadcrumb, newBreadcrumbObj];
          this.sharedService.updateBreadcrumb(newBreadcrumb);
          this.router.navigate(['home', 'mobile'], {
            queryParams: {
              "id": appData.application_id,
            }
          });

        } else {
          const currentParams = { ...this.activatedRoute.snapshot.queryParams };
          this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((x:any) =>{
            let data:any= {...x};
            data['webApplicationName'] = res?.applicationName;
            localStorage.setItem("webMeta",JSON.stringify(data));
            localStorage.setItem('applicationId',this.webApp.application_id);
          });
          currentParams['id'] = appData.application_id;
          this.router.navigate(['home', 'web'], {
            queryParams: {
              "id": appData.application_id,
            }
          });
        }
        this.sharedService.setStepperIndexValue(false);
        this.spinnerVisible = false;
      },
      error: (err: any) => {
        this.spinnerVisible = false;
        if(err?.status == 403) {
          this.toasterSrv.showError('You do not have permission to access this resource.');
        }else if (err.status == 409) {
          this.sharedService.setStepperIndexValue(true);
        } else {
          this.toasterSrv.showError("Error while Creating Application");
        }

      }
    })
  }

  addApplicationLogo(applicationId: string, applicationLogo: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPLOAD_MEDIA_IMAGE']);
      apiConfig.postData = {
        applicationId: applicationId,
        resource: applicationLogo,
        application_logo:true,
        
      };
  
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
          this.s3ImageUrl = data?.resource.resource_url;
          this.resourceData = data?.resource;
          resolve(data?.image);
        },
        error: (err: any) => {
          this.spinnerVisible = false;
          if(err?.status == 403) {
            this.toasterSrv.showError('You do not have permission to access this resource.');
          }
          reject(err);
        }
      });
    });
  }  
 

  async createWebApplicationDialog(){

    if(this.webAppExists)
    {
      const currentBreadcrumb = this.webSharedService.getCurrentBreadcrumb();
      const newBreadcrumbObj = { id: this.webApplicationId, label: this.webApplicationName, state: 'web'};
      const newBreadcrumb = [...currentBreadcrumb, newBreadcrumbObj];
      this.webSharedService.updateBreadcrumb(newBreadcrumb);
      this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((x:any) =>{
        let data:any= {...x};
        data['webApplicationName'] = this.webApplicationName
        localStorage.setItem("webMeta",JSON.stringify(data))
        if(!isNullOrUndefined(this.webApp)){
          this.webSharedService.setApplicationDataEntire(this.webApp);
          this.sharedService.setApplicationDataEntire(this.webApp)
        }
        localStorage.setItem('applicationId',this.webApp.application_id);
        this.router.navigate(["home","web"], {
          queryParams: {
            "id":this.webApplicationId,
          }
        }); 
      })
    }else 
    {
      const dialogRef = this.dialog.open(ProjectTypeComponent,{
        disableClose: true,
        data:{
          appType:1,
          projectID: this.projectId,
          existedApplicationName: this.existedApplication
        }
      });
      this.getDefaultImage();
      this.defPages = await this.sharedDataService.getAllDefaultPages(this.web_type_uuid);
      dialogRef.componentInstance.dataChanged.pipe(takeUntil(this.destroy$)).subscribe((formData) => {
        if(typeof (formData) !== 'boolean'){
          this.createApplication(formData,this.projectId,this.web_type_uuid, dialogRef);
        }
      })
    }
  }

  async createMobileApplicationDialog()
  {
    if(this.mobileAppExists)
    {
      const currentParams = { ...this.activatedRoute.snapshot.queryParams };
      currentParams['id'] = this.MobileApp.application_id;
      const currentBreadcrumb = this.sharedService.getCurrentBreadcrumb();

      const newBreadcrumbObj = { id: this.mobileApplicationId, label: this.mobileApplicationName, state: 'mobile' };
      const newBreadcrumb = [...currentBreadcrumb, newBreadcrumbObj];
      this.sharedService.updateBreadcrumb(newBreadcrumb);
      this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((x:any) =>{
        let data:any= {...x};
        data['mobileAppId']=this.MobileApp?.application_id
        data['image'] = this.MobileApp?.image
        data['mobileApplicationName'] = this.mobileApplicationName
        data['projectName'] = this.projectName
        localStorage.setItem("mobileMeta",JSON.stringify(data))
        localStorage.setItem("appDetails",JSON.stringify(data))
      })
      if(!isNullOrUndefined(this.MobileApp)){
        this.sharedService.setApplicationDataEntire(this.MobileApp)
        this.router.navigate(['home','mobile'], {
          queryParams: {
            "id":this.MobileApp.application_id,
            "applicationType": this.Mobile_type_uuid,
          }
        });
      }
      this.getAllPages(this.MobileApp.application_id)
      // this.router.navigate(["mobile"]);
      
    }else {
      const dialogRef = this.dialog.open(ProjectTypeComponent,{
        disableClose: true,
        data:{
          appType:2,
          projectID: this.projectId,
          existedApplicationName: this.existedApplication
        }
      });
      this.defPages = await this.sharedDataService.getAllDefaultPages(this.Mobile_type_uuid);

      dialogRef.componentInstance.dataChanged.pipe(takeUntil(this.destroy$)).subscribe((formData) => {
        if(typeof (formData) !== 'boolean'){
          this.createApplication(formData,this.projectId,this.Mobile_type_uuid, dialogRef);
        }
      })
    }
  }


  editMobileNavigation()
  {
    this.sharedService.setSelectedOption('Settings',true);
    const currentParams = { ...this.activatedRoute.snapshot.queryParams };
    currentParams['id'] = this.MobileApp.application_id;
    this.router.navigate(['home','mobile'], {
      queryParams: {
        "id":this.MobileApp.application_id,
      }
    });
  }

  editWebNavigation()
  {
    const currentParams = { ...this.activatedRoute.snapshot.queryParams };
    currentParams['id'] = this.webApp.application_id;
    this.router.navigate(['home','web'], {
      queryParams: {
        "id":this.webApp.application_id,
      }
    });
  }

  createApplicationDialog(){
    const dialogData = {
      projectId:this.projectId
    };
    const dialogRef = this.dialog.open(ProjectTypeComponent,{
      disableClose: true,
      data:dialogData
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
    });
  }

  getAllPages(applicationId : string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);
    apiConfig.postData = {application_id: applicationId}
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
      },
      error: (err: any) => {

      }
    })
  }

  getDefaultImage(): Promise<File> {
    const defaultImageUrl = './assets/images/defaultWebLogo.jpg';
    return new Promise((resolve, reject) => {
      this.http.get(defaultImageUrl, { responseType: 'blob' }).pipe(takeUntil(this.destroy$)).subscribe(
        (data: Blob) => {
          const fileName = 'defaultImage.png'; 
          const fileType = 'image/png'; 
          const lastModified = Date.now(); 
          const defaultImageFile = new File([data], fileName, { type: fileType, lastModified: lastModified });

          // this.defaultwebImage = defaultImageFile;
          const reader = new FileReader();
          reader.onloadend = () => {
              if(reader.result){
              this.defaultwebImage = this.removeDataUriPrefix(reader.result);
              }
          };
          reader.readAsDataURL(defaultImageFile);
          resolve(defaultImageFile);
        },
        error => {
          console.error('Failed to fetch the default image: ',error);
          reject(error);
        }
      )
    });
  }

  removeDataUriPrefix(input : any) {
    const prefix = 'data:image/png;base64,';
    if (input.startsWith(prefix)) {
        return input.replace(prefix, '');
    }
    return input;
}

  onClickBreadcrumb(breadcrumbValue: any, index: any){
    this.sharedService.navigateByBreadcrumb(breadcrumbValue, index);
  }

  capitalizeWords(inputString: string): string {
    const words = inputString.split(' ');
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    const capitalizedString = capitalizedWords.join(' ');
    return capitalizedString;
  }
  revertSetDataInSharedSrv(){
    this.sharedService.setThemeData(null);
    this.sharedService.setApplicationDataEntire(null);
    this.sharedService.setApplicationData(null);
    this.sharedService.setApplicationDataById(null)
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
